//CONSTANTS
import {
  GET_ACTIVITY,
  GET_ACTIVITY_SUCCESS,
  GET_ACTIVITY_BY_ID,
  GET_ACTIVITY_BY_ID_SUCCESS,
  POST_ACTIVITY,
  POST_ACTIVITY_SUCCESS,
  PATCH_ACTIVITY_BY_ID,
  PATCH_ACTIVITY_BY_ID_SUCCESS,
  DELETE_ACTIVITY_BY_ID,
  DELETE_ACTIVITY_BY_ID_SUCCESS,
} from "../Activity/constants.js"

const initialState = {
  activityList: [],
  activitySelect: {},
}

function activityDataReducer(state = initialState, { type, payload }) {
  switch (type) {
    //**************************************************************************
    //********************** REDUCER LIST CHOICE *******************************
    //**************************************************************************
    case GET_ACTIVITY_SUCCESS:
      return {
        ...state,
        activityList: payload,
      }
    case GET_ACTIVITY_BY_ID_SUCCESS:
      return {
        ...state,
        activitySelect: payload,
      }
    default:
      return state
  }
}

export default activityDataReducer
